import React, { useEffect, useState } from "react";
import "./Reviews.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faStar,
    faChevronDown,
    faChevronUp,
    faThumbsUp,
    faThumbsDown,
} from "@fortawesome/free-solid-svg-icons";

import products from "../review_sentiment_updated.json";

const Reviews = ({ barcode, starRating, category }) => {
    const [productData, setProductData] = useState(null);
    const [showReviews, setShowReviews] = useState(false);

    const MAX_REVIEWS_PER_SENTIMENT = 5;

    useEffect(() => {
        const allProducts = Object.values(products).flat();
        const foundProduct = allProducts.find((item) => item.Barcode === barcode);
        setProductData(foundProduct);
    }, [barcode]);

    if (!productData) {
        return <div className="reviews-loading">Yükleniyor...</div>;
    }

    const { Total, Positive, Negative, Positive_Reviews, Negative_Reviews, Removed_Reviews, ByType } = productData;
    const positiveRatio = Math.round((Positive / Total) * 100);
    const negativeRatio = Math.round((Negative / Total) * 100);

    const posSlice = Positive_Reviews.slice(0, MAX_REVIEWS_PER_SENTIMENT);
    const negSlice = Negative_Reviews.slice(0, MAX_REVIEWS_PER_SENTIMENT);

    const removedSet = new Set(Removed_Reviews);

    const interleavedReviews = [];
    for (let i = 0; i < Math.max(posSlice.length, negSlice.length); i++) {
        if (posSlice[i] && !removedSet.has(posSlice[i])) {
            interleavedReviews.push({ text: posSlice[i], sentiment: "positive" });
        }
        if (negSlice[i] && !removedSet.has(negSlice[i])) {
            interleavedReviews.push({ text: negSlice[i], sentiment: "negative" });
        }
    }

    const renderStars = (rating) => {
        const fullRating = Math.round(rating);
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <FontAwesomeIcon
                    key={i}
                    icon={faStar}
                    className={`review-star ${i <= fullRating ? "review-star-filled" : ""}`}
                />
            );
        }
        return stars;
    };

    return (
        <div className="reviews-page-container">
            <div className="reviews-card-new">
                <div className="rating-summary">
                    <div className="stars-row">{renderStars(starRating)}</div>
                    <div className="rating-number">
                        <span>{starRating ? `${starRating}/5` : ''}</span>
                    </div>
                    <div className="total-count">
                        <span>Toplam Yorum: {Total}</span>
                    </div>
                </div>

                {interleavedReviews.length > 0 && (<div className="overall-ratio-badge">
                    <div className="ratio-badge-content">
                        <FontAwesomeIcon icon={faThumbsUp} className="thumbs-up-icon" />
                        <span>{positiveRatio}%</span>
                        <span className="ratio-divider">|</span>
                        <span>{negativeRatio}%</span>
                        <FontAwesomeIcon icon={faThumbsDown} className="thumbs-down-icon" />
                    </div>
                </div>)}

                <div className="reviews-type-section-new">
                    <h4>{category ? `Cilt Tipine Göre` : `Saç Tipine Göre`}</h4>
                    <div className="type-list-new">
                        {ByType?.map((typeObj, index) => {
                            if (typeObj.type === "unknown") return null;
                            const typePosRatio = Math.round((typeObj.positive / typeObj.total) * 100);
                            const typeNegRatio = 100 - typePosRatio;
                            return (
                                <div key={index} className="type-item-new">
                                    <span className="type-name-new">{typeObj.type}</span>
                                    <div className="type-ratio-new">
                                        <div className="type-ratio-bar">
                                            <div
                                                className="liked-segment"
                                                style={{ width: `${typePosRatio}%` }}
                                            ></div>
                                            <div
                                                className="disliked-segment"
                                                style={{ width: `${typeNegRatio}%` }}
                                            ></div>
                                        </div>
                                        <div className="type-ratio-values">
                                            {typePosRatio > 0 && (
                                                <>
                                                    <FontAwesomeIcon
                                                        icon={faThumbsUp}
                                                        style={{ color: "#66bb6a", marginRight: "4px" }}
                                                    />
                                                    <span>{typePosRatio}%</span>
                                                </>
                                            )}
                                            {typePosRatio > 0 && typeNegRatio > 0 && (
                                                <span style={{ margin: "0 12px" }}>|</span>
                                            )}
                                            {typeNegRatio > 0 && (
                                                <>
                                                    <FontAwesomeIcon
                                                        icon={faThumbsDown}
                                                        style={{ color: "#ef5350", marginRight: "4px" }}
                                                    />
                                                    <span>{typeNegRatio}%</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <button
                    className="toggle-reviews-button"
                    onClick={() => setShowReviews(!showReviews)}
                >
                    {showReviews ? "Yorumları Gizle" : "Yorumları Göster"}
                    <FontAwesomeIcon icon={showReviews ? faChevronUp : faChevronDown} />
                </button>
            </div>

            {showReviews && (
                <div className="reviews-list-container-new">
                    <h3>Kullanıcı Yorumları</h3>
                    <div className="reviews-list-new">
                        {interleavedReviews.length > 0 ? (
                            <div className="reviews-list-new">
                                {interleavedReviews.map((review, idx) => (
                                    <div key={idx} className={`review-item-new ${review.sentiment}`}>
                                        <span className="review-text-new">“{review.text}”</span>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="no-reviews-message">Yorum bulunamadı.</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Reviews;
